import { Form, Modal, Spin } from 'antd';

import { Phone } from '@app/components/Phone';
import type { PhoneState } from '@app/components/Phone/types';
import { CANCEL, SAVE } from '@app/constants';

import { useUserContactPhoneModal } from './useUserContactPhoneModal';

import type { FC } from 'react';

const PHONE_MODAL_WIDTH_PX = 360;

interface UserContactPhoneModalProps {
  isOpen: boolean;
  initialPhone: PhoneState | null;
  isLoading: boolean;
  isSaving: boolean;
  isRequired: boolean;
  onSave(phone: PhoneState): void;
  onCancel(): void;
}

// Колонке деталей не хватает ширины на строку с флагом, полем ввода и двумя
// кнопками — номер обрезался, поэтому телефон правится в отдельном окне.
export const UserContactPhoneModal: FC<UserContactPhoneModalProps> = ({
  isOpen,
  initialPhone,
  isLoading,
  isSaving,
  isRequired,
  onSave,
  onCancel,
}) => {
  const { form, canSave, validationHandler, finishHandler, submitHandler } =
    useUserContactPhoneModal({ isOpen, initialPhone, isRequired, onSave });
  const isReady = !isLoading && Boolean(initialPhone);

  return (
    <Modal
      open={isOpen}
      title="Телефон клиента"
      className="UserContactPhoneModal"
      width={PHONE_MODAL_WIDTH_PX}
      okText={SAVE}
      cancelText={CANCEL}
      onOk={submitHandler}
      onCancel={onCancel}
      okButtonProps={{
        loading: isSaving,
        disabled: !isReady || !canSave,
      }}
      cancelButtonProps={{ disabled: isSaving }}
      destroyOnHidden
    >
      {initialPhone ? (
        <Form
          form={form}
          initialValues={{ Phone: initialPhone }}
          onFinish={finishHandler}
        >
          <Form.Item name="Phone" noStyle>
            <Phone
              name="Phone"
              required={isRequired}
              disabled={isSaving}
              wrapperClassName="UserContactPhoneModal__input"
              phoneInputDataTestId="lead-client-phone-input"
              onValidate={validationHandler}
            />
          </Form.Item>
        </Form>
      ) : (
        <div className="UserContactPhoneModal__loading">
          <Spin size="small" />
        </div>
      )}
    </Modal>
  );
};
